import TestCompenps from './app.vue'
export default TestCompenps



// WEBPACK FOOTER //
// ./src/index.js